var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sns"},_vm._l((_vm.list),function(sns){return _c('a',{key:sns.id,attrs:{"href":sns.url,"target":"_blank"}},[_c('img',{attrs:{"src":require(("@/assets/img/sns_" + (sns.id) + ".png")),"alt":sns.label}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }